<template>
  <emoji-picker
    v-if="emojiIndex"
    :data="emojiIndex"
    :title="$t('common.pickYourEmoji')"
    emoji="point_up"
    @select="selectEmoji"
  />
</template>

<script lang="ts" setup>
import { Picker as EmojiPicker, EmojiIndex } from 'emoji-mart-vue-fast/src'
import { ref } from '@/composition/vue/compositionApi'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import { getEmojiData } from '@/utils/emojiHelpers'

import type { Emoji } from '@/services/forms/tmTiptap/types'

const emit = defineEmits<{
  (e: 'select', emoji: Emoji): void
  (e: 'emoji-loaded'): void
}>()

const emojiIndex = ref()

getEmojiData().then((data) => {
  emojiIndex.value = new EmojiIndex(data.default)
  emit('emoji-loaded')
})

const selectEmoji = (emoji: EmojiIndex) => {
  emit('select', emoji as Emoji)
}
</script>
